import { render, staticRenderFns } from "./BlogItem.vue?vue&type=template&id=4735d622&scoped=true&"
import script from "./BlogItem.vue?vue&type=script&lang=js&"
export * from "./BlogItem.vue?vue&type=script&lang=js&"
import style0 from "./BlogItem.vue?vue&type=style&index=0&id=4735d622&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4735d622",
  null
  
)

export default component.exports